export default __webpack_public_path__ + "static/media/hue-map.4ee42d6d.png";